<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-lab-sidebar></app-lab-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                  card-header-responsive
                "
              >
                <div class="card-heading">
                  <h4>List of Logged Samples</h4>
                </div>

                <div class="button-section mt-1">
                  <button
                    type="button"
                    class="mr-4 small-btn-dash mt-6px"
                    id="viewBulkUploadResultModal"
                    (click)="
                      showBulkUploadResultModal(viewBulkUploadResultModal)
                    "
                  >
                    Upload Bulk Results <i class="fas fa-cloud-upload-alt"></i>
                  </button>

                  <!-- <button
                    class="d-none"
                    type="button"
                    id="viewUploadResultModal"
                    (click)="showModal(viewUploadResultModal)"
                  >
                    viewUploadResultModal
                  </button> -->
                  <button
                    type="button"
                    class="d-none"
                    id="viewStatusModal"
                    (click)="showModal(viewStatusModal)"
                  >
                    viewStatusModal
                  </button>
                </div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="row">
                        <div class="col-lg-3  col-sm-6  col-md-6 mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="traveller_type"
                            formControlName="traveller_type"
                            id="traveller_type"
                          >
                            <option selected value="">Type of Traveller</option>
                            <option
                              *ngFor="let type of shared.travelTypes"
                              [value]="type.id"
                            >
                              {{ type.name }}
                            </option>
                          </select>
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6   mt-320_view">
                          <input
                            class="form-control icon-cal font-12"
                            type="text"
                            formControlName="daterangeInput"
                            placeholder="Enrollment: Date From - Date To"
                            daterangepicker
                            [options]="options"
                            (selected)="selectedDate($event, daterange)"
                            title="Enrollment: Date From - Date To"
                          />
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6   mt-320_view">
                          <select
                            class="form-select select-option col-lg-12"
                            name="payment_status"
                            formControlName="payment_status"
                            id="payment_status"
                          >
                            <option selected value="">Payment Status</option>
                            <option value="1">Paid</option>
                            <option value="0">Unpaid</option>
                          </select>
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6   mt-320_view">
                          <div class="">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="">
                    <div class="table-responsive mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="loggedSamples">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>

                      <table
                        *ngIf="loggedSamples"
                        class="
                          table
                          table-bordered
                          table-condensed
                          table-responsive-sm
                          table-responsive-md
                          table-responsive-lg
                          table-responsive-xl
                          nowrap
                        "
                        datatable
                        [dtOptions]="dtOptions"
                        width="100%"
                      >
                        <thead class="">
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">Appointment ID</th>
                            <th scope="col">Surname</th>
                            <th scope="col">First Name</th>
                            <!-- <th scope="col">Middle Name</th> -->
                            <th scope="col">Passport Number</th>
                            <th scope="col">Type Of Traveller</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Enrollment Date</th>
                            <th scope="col">Sample Collection Date</th>
                            <th scope="col">Sample Collection Center</th>
                            <th scope="col">Payment Status</th>
                            <th scope="col">Upload Result</th>
                          </tr>
                        </thead>
                        <tbody class="dashboard-bg-white">
                          <tr
                            *ngFor="
                              let sample of loggedSamples | paginate: config;
                              index as i
                            "
                          >
                            <th scope="row">
                              {{
                                config.itemsPerPage * (config.currentPage - 1) +
                                  i +
                                  1
                              }}
                            </th>
                            <td>{{ sample.ctms_passenger_id }}</td>
                            <td>{{ sample.last_name }}</td>
                            <td>{{ sample.first_name }}</td>
                            <!-- <td>{{ sample.middle_name }}</td> -->
                            <td>{{ sample.passport_no }}</td>
                            <td>
                              <span *ngIf="sample.type == '1'">
                                Departing EG
                              </span>
                              <span *ngIf="sample.type == '2'">
                                Arriving EG
                              </span>
                            </td>
                            <td>{{ sample.phone }}</td>
                            <td>{{ sample.created_at | date: "medium" }}</td>
                            <td>
                              {{
                                sample.booking_date + " " + sample.booking_time
                                  | date: "medium"
                              }}
                            </td>
                            <td>{{ sample.center_name }}</td>
                            <td>
                              <span
                                *ngIf="sample.payment_status"
                                class="text-success"
                                >Paid</span
                              >
                              <span
                                *ngIf="!sample.payment_status"
                                class="text-warning"
                                >Unpaid</span
                              >
                            </td>
                            <td>

                              <button
                                class="btn-view"
                                type="button"
                                (click)="
                                  showUploadResult(
                                    sample,
                                    viewUploadResultModal
                                  )
                                "
                                title="Upload result"
                                *ngIf="sample.result_submitted == 'FALSE'"
                              >
                                <i class="fas fa-cloud-upload-alt"></i>
                              </button>
                                                           
                              <span
                                class="text-success"
                                *ngIf="sample.result_submitted == 'TRUE'"
                              >
                                Result Submitted
                              </span>

                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="loggedSamples"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="loggedSamples"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #viewSearchAppointmentModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>Upload Result</h3>
        <button
          type="button"
          class="close-button"
          (click)="modal.close('Save click')"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body">
        <form
          [formGroup]="searchAppointmentForm"
          (ngSubmit)="onSearchAppointment(searchAppointmentForm.value)"
        >
          <div class="row">
            <div class="col-md-8 offset-md-1">
              <div class="form-group row">
                <label for="appointment_id" class="col-md-4 col-form-label"
                  >Appointment ID</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="appointment_id"
                    name="appointment_id"
                    placeholder="Appointment ID e.g OUB54927161"
                    [ngClass]="{ 'is-invalid': submitted &amp;&amp; searchAppointmentForm.controls.appointment_id.errors }"
                  />

                  <div
                    *ngIf="submitted &amp;&amp; searchAppointmentForm.controls.appointment_id.errors"
                    class="form-text text-danger"
                  >
                    <div
                      *ngIf="
                        searchAppointmentForm.controls.appointment_id.errors
                          .required
                      "
                    >
                      Appointment ID is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-5 offset-md-7">
                  <button type="submit" class="btn btn-primary theme-btn">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template> -->

<!-- <ng-template #viewUploadResultModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        ">
        <h3>Upload Result</h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">

        <div class="container">
          <form [formGroup]="uploadResultForm" (ngSubmit)="onUploadResult(uploadResultForm.value)">
            <div class="row">
              <div class="col-lg-6 mt-2 font-weight-bolder">
                Appointment ID:
              </div>
              <div class="col-lg-6 mt-2">
                {{ sampleSingleResponse.ctms_passenger_id }}
              </div>

              <div class="col-lg-6 mt-2 font-weight-bolder">
                Name of Passenger:
              </div>
              <div class="col-lg-6 mt-2">
                {{ sampleSingleResponse.first_name }}
                {{ sampleSingleResponse.middle_name }}
                {{ sampleSingleResponse.last_name }}
              </div>

              <div class="col-lg-6 mt-2 font-weight-bolder">
                Passport Number:
              </div>
              <div class="col-lg-6 mt-2">
                {{ sampleSingleResponse.passport_no }}
              </div>

    
              <div class="col-lg-6 mt-2 font-weight-bolder">
                Sample Collection Date:
              </div>
              <div class="col-lg-6 mt-2">
                {{
                sampleSingleResponse.booking_date +
                " " +
                sampleSingleResponse.booking_time | date: "medium"
                }}
              </div>


              <div class="col-lg-3 font-weight-bolder">Status:</div>
              <div class="col-lg-6 offset-lg-3">
                <div class="form-group row">
                  <div class="col-md-5 mt-3">
                    <select class="form-control select-option mb-2" name="status" formControlName="status" id="status">
                      <option selected value="">Select Status</option>
                      <option value="POSITIVE">POSITIVE</option>
                      <option value="NEGATIVE">NEGATIVE</option>
                    </select>

                    <div *ngIf="submitted &amp;&amp; uploadResultForm.controls.status.errors"
                      class="form-text text-danger">
                      <div *ngIf="uploadResultForm.controls.status.errors.required">
                        Status is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 font-weight-bolder">Validity:</div>
              <div class="col-lg-6 offset-lg-3">
                <div class="form-group row">
                  <div class="col-md-5 mt-3">
                    <input type="date" class="form-control mb-2" name="validity_date" formControlName="validity_date"
                      id="validity_date" placeholder="Validity Date" />

                    <div *ngIf="submitted &amp;&amp; uploadResultForm.controls.validity_date.errors"
                      class="form-text text-danger">
                      <div *ngIf="
                          uploadResultForm.controls.validity_date.errors
                            .required
                        ">
                        Validity date is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            
            </div>

            <div class="row">
              <div class="col-lg-6 offset-lg-6 mt-2">
                <div class="row mt-5 minus-220px">
                  <div class="col-md-12">
                   
                    <button type="submit" class="btn btn-primary theme-btn ml-2">
                      Submit
                    </button>

                    <button type="button" class="btn btn-primary theme-btn ml-2 btn-red"
                      (click)="modal.close('Save click')">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template> -->

<ng-template #viewUploadResultModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>Upload Result</h3>
        <button
          type="button"
          class="close-button"
          (click)="modal.close('Save click')"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">
        <form
          [formGroup]="uploadResultForm"
          (ngSubmit)="onUploadResult(uploadResultForm.value)"
        >
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <div class="form-group row">
                <label for="appointmenId" class="col-md-4 col-form-label"
                  >Appointment ID</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="appointmentId"
                    name="appointmentId"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="fullname" class="col-md-4 col-form-label"
                  >Full name</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="fullname"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="phone" class="col-md-4 col-form-label"
                  >Phone number</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="phone"
                    name=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="passportNumber" class="col-md-4 col-form-label"
                  >Passport Number</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="passportNumber"
                    name=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="date" class="col-md-4 col-form-label"
                  >Collection Date</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="date"
                    name=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="date" class="col-md-4 col-form-label">Result</label>
                <div class="col-md-8">
                  <select
                    class="form-control select-option"
                    name="result"
                    formControlName="result"
                    id="result"
                  >
                    <option selected value="">Select Result</option>
                    <option value="POSITIVE">POSITIVE</option>
                    <option value="NEGATIVE">NEGATIVE</option>
                  </select>

                  <div
                    *ngIf="submitted &amp;&amp; uploadResultForm.controls.result.errors"
                    class="form-text text-danger"
                  >
                    <div
                      *ngIf="uploadResultForm.controls.result.errors.required"
                    >
                      Result is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="result_date" class="col-md-4 col-form-label"
                  >Result Date</label
                >
                <div class="col-md-8">
                  <input
                    type="date"
                    class="form-control"
                    [max]="maxDate"
                    name="result_date"
                    formControlName="result_date"
                    id="result_date"
                    placeholder="Result Date"
                  />

                  <div
                    *ngIf="submitted &amp;&amp; uploadResultForm.controls.result_date.errors"
                    class="form-text text-danger"
                  >
                    <div
                      *ngIf="
                        uploadResultForm.controls.result_date.errors.required
                      "
                    >
                      Result date is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="form-group row">
                <label for="validity_date" class="col-md-4 col-form-label"
                  >Validity</label
                >
                <div class="col-md-8">
                  <input
                    type="date"
                    class="form-control"
                    [min]="minDate"
                    name="validity_date"
                    formControlName="validity_date"
                    id="validity_date"
                    placeholder="Validity Date"
                  />

                  <div
                    *ngIf="submitted &amp;&amp; uploadResultForm.controls.validity_date.errors"
                    class="form-text text-danger"
                  >
                    <div
                      *ngIf="
                        uploadResultForm.controls.validity_date.errors.required
                      "
                    >
                      Validity date is required
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="form-group row">

                                <label for="traveller" class="col-md-4 col-form-label">Travel type</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="traveller" name="">

                                </div>
                            </div> -->

              <!-- <div class="form-group row">

                                <label for="status" class="col-md-4 col-form-label">Payment Status</label>
                                <div class="col-md-8">
                                    <input type="text" disabled class="form-control" formControlName="status" name="">

                                </div>
                            </div> -->

              <div class="form-group row">
                <div class="col-md-8 offset-md-4 mt-5">
                  <div class="col-md-12">
                    <button
                      type="submit"
                      class="btn btn-primary theme-btn ml-2"
                    >
                      Submit
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary theme-btn ml-2 btn-red"
                      (click)="modal.close('Save click')"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewBulkUploadResultModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>Upload Bulk Results</h3>
        <button
          type="button"
          class="close-button"
          (click)="modal.close('Save click')"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">
        <!-- START -->

        <div class="container">
          <form
            [formGroup]="bulkUploadResultForm"
            (ngSubmit)="onBulkUploadResult()"
          >
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="fileInput">Select File to Upload</label>

                <div class="custom-file">
                  <input
                    formControlName="myfile"
                    id="myfile"
                    type="file"
                    class="custom-file-input"
                    (change)="onFileChange($event)"
                    [ngClass]="{
                      'is-invalid':
                        submitted && bulkUploadResultForm.controls.myfile.errors
                    }"
                    accept=".xls,.xlsx"
                    required
                  />
                  <label class="custom-file-label" for="customFile">{{
                    filePath == null ? "Choose file (xlsx or xls)" : filePath
                  }}</label>
                </div>

                <div
                  *ngIf="submitted &amp;&amp; bulkUploadResultForm.controls.myfile.touched && bulkUploadResultForm.controls.myfile.invalid"
                  class="text-danger"
                >
                  <div *ngIf="isValidationError">File is required.</div>
                </div>
              </div>
            </div>

            <div class="button-upload-box">
              <button
                type="submit"
                class="btn btn-primary theme-btn ml-2"
                [disabled]="file == null"
              >
                Upload File
              </button>
              <a
                href="{{ uploadSampleFileTemplate }}"
                target="_blank"
                class="download-file-link"
                >Download Template</a
              >
            </div>
          </form>

          <!-- <form [formGroup]="uploadResultForm" (ngSubmit)="onUploadResult(uploadResultForm.value)">
            <div class="row">

              <div class="col-lg-6 offset-lg-3">
                <div class="form-group row">
                  <div class="col-md-5 mt-3">

                    <label class="font-weight-bolder">Select File to Upload:</label>

                    <input type="file" class="form-control mb-2" placeholder="Upload result" accept=".xlsx" #fileInput
                      (change)="handleFileUpload(fileInput)" />

                    <span><a href="{{ uploadSampleFileTemplate }}" target="_blank">Download Template</a></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 offset-lg-6 mt-2">
                <div class="row mt-5 minus-220px">
                  <div class="col-md-12">

                    <button type="submit" class="btn btn-primary theme-btn ml-2">
                      Upload File
                    </button>

                    <button type="button" class="btn btn-primary theme-btn ml-2 btn-red"
                      (click)="modal.close('Save click')">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form> -->
        </div>
        <!-- END -->
      </div>
    </div>
  </div>
</ng-template>

<!-- <ng-template #viewUploadResultModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>COVID-19 Test</h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">
     

        <div class="container">
          <div class="row">
            <div class="col-lg-6 mt-2 font-weight-bolder">
              Name of Passenger:
            </div>
            <div class="col-lg-6 mt-2">
              {{ sampleSingleResponse.first_name }}
              {{ sampleSingleResponse.middle_name }}
              {{ sampleSingleResponse.last_name }}
            </div>

            <div class="col-lg-6 mt-2 font-weight-bolder">Passport Number:</div>
            <div class="col-lg-6 mt-2">
              {{ sampleSingleResponse.passport_no }}
            </div>

            <div class="col-lg-6 mt-2 font-weight-bolder">Gender:</div>
            <div class="col-lg-6 mt-2">{{ sampleSingleResponse.gender }}</div>

            <div class="col-lg-6 mt-2 font-weight-bolder">
              Sample Collection Date:
            </div>
            <div class="col-lg-6 mt-2">
              {{
                sampleSingleResponse.booking_date +
                  " " +
                  sampleSingleResponse.booking_time | date: "medium"
              }}
            </div>

            <div class="col-lg-6 mt-2 font-weight-bolder">Nationality:</div>
            <div class="col-lg-6 mt-2">
              {{ sampleSingleResponse.nationality }}
            </div>

            <div class="col-lg-6 mt-2 font-weight-bolder">Age:</div>
            <div class="col-lg-6 mt-2">
              {{ sampleSingleResponse.dob | age }}
            </div>

            <div class="col-lg-6 mt-2 font-weight-bolder">Upload Result:</div>
            <div class="col-lg-6 mt-2">
              <form
                [formGroup]="uploadResultForm"
                (ngSubmit)="onUploadResult(uploadResultForm.value)"
              >
                <div class="form-group row">
                  <div class="col-md-8 mt-3">
                    <input
                      type="file"
                      class="form-control mb-2"
                      placeholder="Upload result"
                      accept=".xlsx"
                      #fileInput
                      (change)="handleFileUpload(fileInput)"
                    />

                    <span
                      ><a href="{{ uploadSampleFileTemplate }}" target="_blank"
                        >Download Template</a
                      ></span
                    >
                  </div>
                </div>

                <div class="row mt-5 minus-220px">
                  <div class="col-md-12">
                  

                    <button
                      type="submit"
                      class="btn btn-primary theme-btn ml-2"
                    >
                      Upload
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary theme-btn ml-2 btn-red"
                      (click)="modal.close('Save click')"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template> -->

<ng-template #viewStatusModal let-modal>
  <div class="card col-lg-12 mb-5">
    <div class="card-body p-4">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div>
            <h3 class="text-success mb-5">Uploaded successfully</h3>
          </div>

          <button
            type="button"
            class="btn btn-secondary ml-5"
            (click)="nextPassenger()"
          >
            Next Passenger
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
